import { Disciplines } from "enums/disciplines";
import { FixtureStatuses } from "enums/fixtureStatuses";
import { Roles } from "enums/roles";
import { Standards } from "enums/standards";
import type { SportConfiguration } from "types/sportConfiguration";

const seasonStaffRoles: Array<Roles> = [
  Roles.Coach,
  Roles.CoachAssistant,
  Roles.CoachHead,
  Roles.Director,
  Roles.MediaOfficer,
  Roles.Secretary,
  Roles.Timer,
  Roles.Trainer,
  Roles.Referee,
];

const fixtureStaffRoles: Array<Roles> = [
  Roles.Coach,
  Roles.CoachAssistant,
  Roles.CoachHead,
  Roles.Director,
  Roles.MediaOfficer,
  Roles.Secretary,
  Roles.Timer,
  Roles.Trainer,
  Roles.Referee,
];

const entityStandards: Standards[] = [
  Standards.Elite,
  Standards.Friendly,
  Standards.GrassRoot,
  Standards.International,
  Standards.Olympic,
  Standards.Region,
  Standards.Tier2,
  Standards.Tier3,
  Standards.WorldChampionship,
  Standards.ZoneChampionship,
];

const fixtureStatuses: FixtureStatuses[] = [
  FixtureStatuses.Scheduled,
  FixtureStatuses.Abandoned,
  FixtureStatuses.Bye,
  FixtureStatuses.Cancelled,
  FixtureStatuses.Confirmed,
  FixtureStatuses.Draft,
  FixtureStatuses.Finished,
  FixtureStatuses.IfNeeded,
  FixtureStatuses.InProgress,
  FixtureStatuses.Pending,
  FixtureStatuses.Postponed,
];

const entityDisciplines: Disciplines[] = [Disciplines.Indoor, Disciplines.Outdoor];

export const defaultsConfig: SportConfiguration = {
  rosterPositions: [],
  fixtureStatuses,
  seasonStaffRoles,
  fixtureStaffRoles,
  entityStandards,
  entityDisciplines,
  uniforms: {
    bottomOptions: [],
    items: [],
  },
};
